(() => {
  const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  const strings = window.themeStrings || {};
  const money = (cents) => (window.themeMoney || 'Rs. {{amount}}').replace('{{amount}}', (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

  const announcement = document.querySelector('[data-announcement]');
  if (announcement) {
    const key = 'hg-announcement-' + announcement.dataset.announcement;
    try { if (sessionStorage.getItem(key)) announcement.hidden = true; } catch (e) {}
    announcement.querySelector('[data-announcement-close]')?.addEventListener('click', () => {
      announcement.hidden = true;
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
    });
  }

  const footerDetails = document.querySelectorAll('.footer__menus details');
  const syncFooter = () => footerDetails.forEach((d) => { d.open = window.matchMedia('(min-width: 750px)').matches; });
  syncFooter();
  window.matchMedia('(min-width: 750px)').addEventListener('change', syncFooter);

  const header = document.querySelector('[data-header]');
  if (header) {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        header.classList.toggle('is-scrolled', window.scrollY > 24);
        ticking = false;
      });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const openDialog = (dialog) => { if (dialog && !dialog.open) dialog.showModal(); };
  const menuDrawer = document.getElementById('MenuDrawer');
  document.querySelector('[data-drawer-open]')?.addEventListener('click', () => openDialog(menuDrawer));
  document.querySelectorAll('dialog.drawer').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      // A link inside the drawer may only jump to an anchor on this page, so close it on any link too
      if (event.target === dialog || event.target.closest('[data-drawer-close], a[href]')) dialog.close();
    });
  });

  const search = document.querySelector('[data-search]');
  const searchInput = search?.querySelector('input[type="search"]');
  search?.addEventListener('toggle', () => { if (search.open) searchInput?.focus(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && search?.open) search.open = false; });

  const predictive = document.querySelector('[data-predictive]');
  if (searchInput && predictive && window.fetch) {
    let timer;
    searchInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = searchInput.value.trim();
      if (q.length < 2) { predictive.hidden = true; return; }
      timer = setTimeout(async () => {
        try {
          const url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
          const data = await fetch(url, { headers: { Accept: 'application/json' } }).then((r) => r.json());
          const products = data.resources.results.products || [];
          predictive.innerHTML = products.map((p) => {
            const img = p.featured_image?.url ? '<img src="' + p.featured_image.url + '&width=96" alt="" width="48" height="48" loading="lazy">' : '<span></span>';
            return '<li><a href="' + p.url + '">' + img + '<span>' + p.title.split(' | ')[0].replace('Herbo Green ', '') + '</span><span class="t-muted">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></a></li>';
          }).join('') || '<li class="t-muted t-small" style="padding:8px 0">' + (strings.noResults || 'No products match').replace('__TERMS__', q) + '</li>';
          predictive.hidden = false;
        } catch (error) {
          predictive.hidden = true;
        }
      }, 250);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-qty]');
    if (!button) return;
    const input = button.parentElement.querySelector('input[type="number"]');
    const min = Number(input.min || 0);
    input.value = Math.max(min, Number(input.value || 0) + Number(button.dataset.qty));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  const cartForm = document.getElementById('CartForm');
  cartForm?.addEventListener('change', (event) => {
    if (event.target.matches('[data-cart-qty]')) {
      clearTimeout(cartForm._timer);
      cartForm._timer = setTimeout(() => {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'update'; input.value = '1';
        cartForm.append(input);
        cartForm.submit();
      }, 500);
    }
  });

  const sort = document.querySelector('[data-sort]');
  sort?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  const updateCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };

  const cartDrawer = document.getElementById('CartDrawer');
  const refreshDrawer = async () => {
    if (!cartDrawer) return;
    const data = await fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const fresh = new DOMParser().parseFromString(data['cart-drawer'], 'text/html').getElementById('CartDrawer');
    cartDrawer.innerHTML = fresh.innerHTML;
    cartDrawer.dataset.count = fresh.dataset.count;
    updateCount(Number(fresh.dataset.count));
  };
  document.querySelector('[data-cart-open]')?.addEventListener('click', (event) => {
    if (!cartDrawer) return;
    event.preventDefault();
    refreshDrawer().catch(() => {}).finally(() => openDialog(cartDrawer));
  });
  cartDrawer?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-line-qty]');
    if (!button) return;
    button.setAttribute('aria-busy', 'true');
    try {
      await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: button.dataset.lineKey, quantity: Number(button.dataset.lineQty) })
      });
      await refreshDrawer();
    } catch (error) {
      button.removeAttribute('aria-busy');
    }
  });

  const addToCart = async (body) => {
    const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
    if (!response.ok) throw new Error(String(response.status));
    try { await refreshDrawer(); } catch (error) {
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      updateCount(cart.item_count);
    }
    openDialog(cartDrawer);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-quick-add]');
    if (!button) return;
    const label = button.textContent;
    button.textContent = strings.adding || 'Adding…';
    button.setAttribute('aria-busy', 'true');
    const body = new FormData();
    body.append('id', button.dataset.quickAdd);
    body.append('quantity', '1');
    try { await addToCart(body); } catch (error) { button.textContent = strings.error || 'Could not add'; return; }
    button.textContent = label;
    button.removeAttribute('aria-busy');
  });

  const productForm = document.querySelector('form.product-form');
  if (productForm && window.fetch) {
    const status = document.querySelector('[data-product-status]');
    const price = document.querySelector('[data-product-price]');
    productForm.addEventListener('change', (event) => {
      if (event.target.name === 'id' && event.target.dataset.price && price) {
        price.querySelector('.price').textContent = event.target.dataset.price;
      }
    });
    productForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = productForm.querySelector('[type="submit"]');
      submit.setAttribute('aria-busy', 'true');
      try {
        await addToCart(new FormData(productForm));
        if (status) status.innerHTML = (strings.added || 'Added to your bag.') + ' <a class="t-link" href="' + root + 'cart">' + (strings.viewBag || 'View bag') + '</a>';
      } catch (error) {
        if (status) status.textContent = strings.error || 'Could not add this to your bag.';
      } finally {
        submit.removeAttribute('aria-busy');
      }
    });

    const buyBar = document.querySelector('[data-buy-bar]');
    const mainButton = productForm.querySelector('.product__buy .button');
    if (buyBar && mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        buyBar.hidden = entry.isIntersecting || entry.boundingClientRect.top > window.innerHeight;
      }, { threshold: 0 }).observe(mainButton);
    }
  }

  // A sticky product column taller than the screen sticks by its bottom edge, so its last rows stay reachable
  const productInfo = document.querySelector('.product__info');
  if (productInfo && 'ResizeObserver' in window) {
    const fitInfo = () => { productInfo.style.top = Math.min(64, window.innerHeight - productInfo.offsetHeight) + 'px'; };
    new ResizeObserver(fitInfo).observe(productInfo);
    window.addEventListener('resize', fitInfo, { passive: true });
  }

  const campaignBar = document.querySelector('[data-campaign-bar]');
  const campaignButton = document.querySelector('[data-campaign-button]');
  if (campaignBar && campaignButton && 'IntersectionObserver' in window) {
    // Same rule as the product page: only once the main Buy now has scrolled away above, so the bar never covers the offers
    new IntersectionObserver(([entry]) => {
      campaignBar.hidden = entry.isIntersecting || entry.boundingClientRect.top > window.innerHeight;
    }, { threshold: 0 }).observe(campaignButton);
  }
  const campaignBarPrice = document.querySelector('[data-campaign-bar-price]');
  // The closing Buy now buys whatever was picked in the offers, not always the single bottle
  const campaignOffers = document.querySelector('.cbuy__offers');
  const closingButton = document.querySelector('.ccta__form [type="submit"]');
  const closingPrice = document.querySelector('.ccta__price');
  if (campaignOffers && closingButton) {
    closingButton.setAttribute('form', campaignOffers.closest('form').getAttribute('id'));
    document.querySelector('.ccta .product__saving')?.remove();
    const picked = campaignOffers.querySelector('input:checked');
    if (closingPrice && picked) closingPrice.textContent = picked.dataset.price;
  }
  campaignOffers?.addEventListener('change', (event) => {
    if (!event.target.dataset.price) return;
    if (campaignBarPrice) campaignBarPrice.textContent = event.target.dataset.price;
    if (closingButton && closingPrice) closingPrice.textContent = event.target.dataset.price;
  });

  document.querySelectorAll('.hero__media video').forEach((video) => {
    const still = video.parentElement.querySelector('.hero__still--poster');
    if (!still) return;
    still.classList.add('is-waiting');
    const reveal = () => still.classList.remove('is-waiting');
    video.addEventListener('playing', reveal, { once: true });
    if (!video.paused && video.readyState >= 3) reveal();
  });

  // Wishlist: handles in localStorage, no account needed.
  const WISH_KEY = 'hg-wishlist';
  const readWish = () => { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; } };
  const writeWish = (list) => { try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {} };
  const syncWishButtons = () => {
    const list = readWish();
    document.querySelectorAll('[data-wishlist]').forEach((button) => {
      const on = list.includes(button.dataset.wishlist);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      const label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = on ? label.dataset.on : label.dataset.off;
      if (!label) button.setAttribute('aria-label', on ? (strings.removeFromWishlist || 'Remove from wishlist') : (strings.saveToWishlist || 'Save to wishlist'));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => { el.textContent = list.length; el.hidden = list.length === 0; });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist]');
    if (!button) return;
    event.preventDefault();
    const handle = button.dataset.wishlist;
    const list = readWish();
    const index = list.indexOf(handle);
    if (index === -1) list.unshift(handle); else list.splice(index, 1);
    writeWish(list);
    syncWishButtons();
    if (index !== -1 && button.closest('[data-wishlist-page]')) {
      button.closest('.card')?.remove();
      renderWishlistSummary();
    }
  });
  syncWishButtons();

  const wishPage = document.querySelector('[data-wishlist-page]');
  const renderWishlistSummary = () => {
    if (!wishPage) return;
    const n = readWish().length;
    wishPage.querySelector('[data-wishlist-summary]').textContent = n ? (n === 1 ? (strings.wishOne || '1 saved item') : (strings.wishMany || '__N__ saved items').replace('__N__', n)) : '';
    wishPage.querySelector('[data-wishlist-empty]').hidden = n > 0;
    wishPage.querySelector('[data-wishlist-grid]').hidden = n === 0;
  };
  if (wishPage && window.fetch) {
    const grid = wishPage.querySelector('[data-wishlist-grid]');
    const tpl = wishPage.querySelector('[data-wishlist-card]');
    renderWishlistSummary();
    Promise.all(readWish().map((handle) => fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null)))
      .then((products) => {
        products.filter(Boolean).forEach((p) => {
          const node = tpl.content.firstElementChild.cloneNode(true);
          node.dataset.productHandle = p.handle;
          node.querySelector('[data-wishlist]').dataset.wishlist = p.handle;
          node.querySelectorAll('a').forEach((a) => { a.href = p.url; });
          const img = node.querySelector('img');
          const src = (p.featured_image || (p.images && p.images[0]) || '');
          if (src) img.src = src.includes('cdn.shopify.com') ? src.replace(/(\.[a-z]+)(\?|$)/, '_900x$1$2') : src; else img.remove();
          node.querySelector('.card__title').textContent = p.title.split(' | ')[0].replace('Herbo Green ', '');
          node.querySelector('.card__price').textContent = p.available ? money(p.price) : (strings.soldOut || 'Sold out');
          const add = node.querySelector('[data-quick-add]');
          const variant = (p.variants || [])[0];
          if (p.available && variant && (p.variants.length === 1)) add.dataset.quickAdd = variant.id; else add.remove();
          grid.append(node);
        });
        syncWishButtons();
      });
  }

  document.querySelectorAll('[data-hover-video]').forEach((media) => {
    const video = media.querySelector('video');
    if (!video) return;
    const card = media.closest('.card');
    const play = () => { video.play().then(() => media.classList.add('is-playing')).catch(() => {}); };
    const stop = () => { video.pause(); video.currentTime = 0; media.classList.remove('is-playing'); };
    card.addEventListener('mouseenter', play);
    card.addEventListener('mouseleave', stop);
    card.addEventListener('focusin', play);
    card.addEventListener('focusout', stop);
  });

  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const dots = carousel.querySelector('[data-carousel-dots]');
    const title = carousel.querySelector('[data-carousel-title]');
    const slides = Array.from(track.children);
    if (!slides.length || !dots) return;
    const buttons = slides.map((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'carousel__dot';
      dot.setAttribute('aria-label', String(index + 1) + ' / ' + slides.length);
      dot.addEventListener('click', () => track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' }));
      dots.append(dot);
      return dot;
    });
    const setActive = () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      buttons.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
      if (title) title.textContent = slides[index]?.dataset.title || '';
    };
    track.addEventListener('scroll', () => window.requestAnimationFrame(setActive), { passive: true });
    setActive();
  });
  // Product rows hide their scrollbar; mouse users get previous/next arrows over the card images
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const arrowSvg = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true" focusable="false"><path d="m6 3 5 5-5 5"/></svg>';
    document.querySelectorAll('.row-scroll').forEach((row) => {
      const wrap = document.createElement('div');
      wrap.className = 'row-wrap';
      row.before(wrap);
      wrap.append(row);
      const make = (dir) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'row-arrow row-arrow--' + (dir < 0 ? 'prev' : 'next');
        button.setAttribute('aria-label', dir < 0 ? (strings.previous || 'Previous') : (strings.next || 'Next'));
        button.innerHTML = arrowSvg;
        button.addEventListener('click', () => {
          const card = row.firstElementChild;
          const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 0) : row.clientWidth;
          row.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
        wrap.append(button);
        return button;
      };
      const prev = make(-1);
      const next = make(1);
      const update = () => {
        const media = row.querySelector('.card__media');
        if (media) wrap.style.setProperty('--arrow-top', (media.offsetTop + media.offsetHeight / 2) + 'px');
        const max = row.scrollWidth - row.clientWidth;
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= max - 2;
        prev.hidden = next.hidden = max <= 2;
      };
      row.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
})();
